import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { PartnerForm } from '../../PartnerForm'
import useMutationUpdatePartner from '../../../api/hooks/useMutationUpdatePartner'
import useQueryGetPartnerById from '../../../api/hooks/useQueryGetPartnerById'
import Spinner from '@/common/components/Spinner'
import { PartnerFormValues } from '../../PartnerForm/components'
import { useQueryClient } from '@tanstack/react-query'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'

export function EditPartnerForm() {
	const navigate = useNavigate()
	const { id } = useParams()
	const { data: partner, isLoading } = useQueryGetPartnerById(id!)
	const queryClient = useQueryClient()

	const { mutate: updatePartner } = useMutationUpdatePartner({
		onSuccess: () => {
			toast.success('แก้ไขพาร์ทเนอร์สำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [PartnerQueryKeys.GetPartnerById, id],
			})
			navigate('/operator/partner')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleSubmit = (values: PartnerFormValues) => {
		updatePartner({
			id: id!,
			payload: values,
		})
	}

	if (isLoading || !partner) return <Spinner />

	return (
		<PartnerForm
			mode="edit"
			defaultValues={partner as unknown as Partial<PartnerFormValues>}
			onSubmit={handleSubmit}
		/>
	)
}
